import{BehaviorSubject as r}from"../BehaviorSubject.js";import{multicast as t}from"./multicast.js";function o(o){return function(n){return t(new r(o))(n)}}export{o as publishBehavior};
